import * as _ from 'lodash';

export function h2R(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
}

export function h2RGdal(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: 255
      }
    : null;
}

export function getInitials(name?: string, email?: string): string {
  const initials =
    _.flow(
      (str: string) => _.split(str, ' '),
      (arr: string[]) => _.map(arr, _.first),
      (arr: (string | undefined)[]) => _.take(arr, 2),
      (arr: (string | undefined)[]) => _.join(arr, '')
    )(name || '') ||
    email?.charAt(0) ||
    '';

  return initials.toUpperCase();
}

export const getAngleValue = (value?: number | string): string =>
  value || value === 0 ? `${value}°` : 'N/A';
